import { BaseQueryFn } from "@reduxjs/toolkit/query";
import {
  createApi,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  retry,
} from "@reduxjs/toolkit/query/react";

import { getToken } from "src/core/authentication/bearerToken";
import {
  getTenantIdFromWindowLocation,
  TENANT_HEADER_NAME,
} from "src/core/utils/tenant/tenantRoute";

export const cookieRE = /^(?:.+; )?XSRF-TOKEN=([^;]+).*/;

/**
 * Base query sans retry et sans gestion des erreurs.
 */
const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    const matches = document.cookie.match(cookieRE);
    if (matches?.[1]) {
      headers.set("X-CSRF-TOKEN", matches[1]);
    }

    const tenantId = getTenantIdFromWindowLocation();
    if (tenantId) {
      headers.set(TENANT_HEADER_NAME, tenantId);
    }

    return headers;
  },
});

const baseQueryWithAuth: BaseQueryFn<
  string | { url: string; method?: string; body?: unknown },
  unknown,
  FetchBaseQueryError,
  Record<string, never>,
  FetchBaseQueryMeta
> = async (args, api, extraOptions) => rawBaseQuery(args, api, extraOptions);

/**
 * Base query avec retry.
 */
const baseQueryWithRetry = retry(baseQueryWithAuth, { maxRetries: 3 });

/**
 * Base API avec retry et gestion des erreurs.
 */
export const baseApi = createApi({
  baseQuery: baseQueryWithRetry,
  tagTypes: [],
  endpoints: () => ({}),
  keepUnusedDataFor: 5,
});
